/**
 * Simple event system for client-related events
 */

type EventCallback = (clientId: string) => void;

interface EventSystem {
  events: {
    [key: string]: EventCallback[];
  };
  subscribe: (eventName: string, callback: EventCallback) => void;
  unsubscribe: (eventName: string, callback: EventCallback) => void;
  emit: (eventName: string, clientId: string) => void;
}

// Event names
export const CLIENT_EVENTS = {
  CLIENT_ARCHIVED: "client_archived",
  CLIENT_STATUS_CHANGED: "client_status_changed",
};

// Create a simple event system
export const clientEventSystem: EventSystem = {
  events: {},

  subscribe(eventName: string, callback: EventCallback) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);
  },

  unsubscribe(eventName: string, callback: EventCallback) {
    if (!this.events[eventName]) return;
    this.events[eventName] = this.events[eventName].filter(
      (cb) => cb !== callback
    );
  },

  emit(eventName: string, clientId: string) {
    if (!this.events[eventName]) return;
    this.events[eventName].forEach((callback) => callback(clientId));
  },
};
